function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "28px",
    viewBox: "0 0 25 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 2.128906 0.253906 C 1.816406 0.390625 1.25 0.839844 0.851562 1.261719 L 0.140625 2.015625 L 0.140625 22.679688 L 1.078125 23.574219 L 1.988281 24.5 L 5.597656 24.5 C 8.691406 24.5 9.203125 24.445312 9.488281 23.996094 C 9.714844 23.660156 9.714844 23.378906 9.488281 23.015625 C 9.234375 22.625 8.664062 22.539062 6.109375 22.457031 C 4.402344 22.429688 2.839844 22.230469 2.640625 22.0625 C 2.128906 21.644531 2.101562 3.078125 2.613281 2.574219 C 3.125 2.070312 17.414062 2.101562 17.839844 2.605469 C 18.011719 2.800781 18.183594 3.5 18.238281 4.171875 C 18.324219 5.601562 19.003906 6.214844 19.828125 5.710938 C 20.199219 5.460938 20.3125 5.011719 20.3125 3.667969 C 20.3125 2.128906 20.226562 1.875 19.375 1.0625 L 18.464844 0.140625 L 10.566406 0.0859375 C 6.25 0.0546875 2.441406 0.140625 2.128906 0.253906 Z M 2.128906 0.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.886719 4.816406 C 4.6875 5.011719 4.546875 5.375 4.546875 5.628906 C 4.546875 6.609375 5.199219 6.746094 10.371094 6.664062 C 14.828125 6.578125 15.453125 6.523438 15.738281 6.074219 C 15.964844 5.738281 15.964844 5.460938 15.738281 5.097656 C 15.453125 4.675781 14.828125 4.621094 10.339844 4.535156 C 6.621094 4.480469 5.140625 4.5625 4.886719 4.816406 Z M 4.886719 4.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12.101562 8.289062 C 10.113281 8.902344 7.871094 11.171875 7.273438 13.160156 C 6.308594 16.324219 6.960938 18.929688 9.203125 21.167969 C 11.421875 23.324219 14.433594 24.050781 17.1875 23.101562 L 18.324219 22.707031 L 20.511719 24.835938 C 22.386719 26.683594 22.753906 26.9375 23.410156 26.769531 C 24.6875 26.460938 24.347656 25.535156 22.1875 23.40625 L 20.199219 21.476562 L 21.050781 20.441406 C 22.015625 19.265625 22.726562 17.21875 22.726562 15.679688 C 22.726562 11.425781 18.976562 7.785156 14.660156 7.867188 C 14.003906 7.867188 12.871094 8.0625 12.101562 8.289062 Z M 17.898438 11.03125 C 19.574219 12.125 20.3125 13.523438 20.3125 15.679688 C 20.3125 17.863281 19.574219 19.234375 17.8125 20.382812 C 16.222656 21.421875 13.464844 21.476562 11.847656 20.46875 C 9.6875 19.152344 8.691406 16.546875 9.347656 14.054688 C 9.746094 12.628906 11.476562 10.78125 12.839844 10.386719 C 14.347656 9.941406 16.675781 10.21875 17.898438 11.03125 Z M 17.898438 11.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.886719 9.296875 C 3.949219 10.21875 4.828125 11.285156 6.421875 11.144531 C 7.640625 11.03125 8.265625 10.359375 7.785156 9.574219 C 7.414062 8.988281 5.398438 8.792969 4.886719 9.296875 Z M 4.886719 9.296875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.ee5a0a94.svg";
export { ForwardRef as ReactComponent };